/**
 * Wire-format contract for structured API error responses.
 *
 * Every error body has a `code` discriminator. Consumers narrow via the
 * discriminated union (or via `ApiError.is` on the client).
 */
export enum ApiErrorCode {
  FORBIDDEN = 'forbidden',
  INTERNAL_SERVER_ERROR = 'internal_server_error',
  NOT_FOUND = 'not_found',
  POD_FORBIDDEN = 'pod_forbidden',
  UNAUTHORIZED = 'unauthorized',
  VALIDATION_ERROR = 'validation_error',
}

interface ApiErrorBodyBase {
  code: ApiErrorCode;
}

export interface ForbiddenBody extends ApiErrorBodyBase {
  code: ApiErrorCode.FORBIDDEN;
  message: string;
}

export interface InternalServerErrorBody extends ApiErrorBodyBase {
  code: ApiErrorCode.INTERNAL_SERVER_ERROR;
  message: string;
}

export interface NotFoundBody extends ApiErrorBodyBase {
  code: ApiErrorCode.NOT_FOUND;
  message: string;
}

export interface PodForbiddenBody extends ApiErrorBodyBase {
  code: ApiErrorCode.POD_FORBIDDEN;
  requiredPod: string;
  userPods: string[];
  canonicalJob: string;
}

export interface UnauthorizedBody extends ApiErrorBodyBase {
  code: ApiErrorCode.UNAUTHORIZED;
  message: string;
}

export interface ValidationErrorBody extends ApiErrorBodyBase {
  code: ApiErrorCode.VALIDATION_ERROR;
  message: string;
}

export type ApiErrorBody =
  | ForbiddenBody
  | InternalServerErrorBody
  | NotFoundBody
  | PodForbiddenBody
  | UnauthorizedBody
  | ValidationErrorBody;
